export default "__VITE_ASSET__Bs15$Ina__"